<template>
    <div class="de-pic-text-vertical-wrapper">
        <div class="img" :style="`background-image: url(${sImage});`"></div>
        <div class="text">
            <p class="word">{{title}}</p>
            <p class="num" >{{sValue}}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'de-picture-text-vertical',
    props: {
        image: {
            type: String
        },
        title: {
            type: String
        },
        value: {
            type: String
        }
    },
    watch: {
        image: {
            handler(v) {
                this.sImage = v
            },
            immediate: true
        },
        title: {
            handler(v) {
                this.sLabel = v
            },
            immediate: true
        },
        value: {
            handler(v) {
                this.sValue = v
            },
            immediate: true
        }
    },
    data() {
        return {
            sValue: '',
            sLabel: '',
            sImage: ''
        }
    }
}
</script>

<style lang="less" scoped>
.de-pic-text-vertical-wrapper {
    .img {
        width:32px;
        height: 32px;
        text-align: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .text {
        margin-top: 10px;
        .word {
            font-family: 'PingFangSC-Regular';
            font-size: 14px;
            color: rgba(255, 255, 255, 0.75);
            letter-spacing: 0;
            line-height: 22px;
        }
        .num {
            font-family: 'AgencyFB-Reg';
            color: #FFF;
            font-size: 28px;
        }
    }
}
</style>